import { CaseSection, GoBack, Header, NextCase, Sections } from 'components';
import _get from 'lodash.get';
import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import CustomHelmet from '../components/helmet/helmet.component';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import { graphql } from 'gatsby'

const CasePageWrapper = styled.div`
    color: ${props => props.textColor};
    /* background-color: ${props => props.backgroundColor}; */
`;

export default class CaseTemplate extends PureComponent {
    constructor(props) {
        super(props);

        this.renderWrapper = this.renderWrapper.bind(this);
    }
    componentDidMount() {
        if (document.getElementById('CloneWrapper')) {
            document.getElementById('CloneWrapper').classList.add('unfix');
        }
    }
    renderWrapper() {
        const { data } = this.props;

        let caseSections = [];
        data.page.modules.forEach(el => {
            if (el && el.__typename == 'DatoCmsCaseSection') {
                caseSections.push({
                    sectionTitle: el.sectionTitle,
                    id: el.id,
                });
            }
        });

        let seoImage = {
            url: '',
            width: 0,
            height: 0,
        };
        data.page.hero.forEach(el => {
            if (el.__typename == 'DatoCmsHeroImage' && el.image) {
                seoImage.url = `${el.image.url}?w=1000`;
                seoImage.width = el.image.width;
                seoImage.height = el.image.height;
            }
        });
        const pageBackgroundColor = _get(
            data,
            'page.backgroundColor.hex',
            '#fff'
        );
        const textColor = _get(data, 'page.textColor.hex', '#000');

        let sections = this.props;
        if (
            sections.data.page.modules &&
            sections.data.page.modules.length &&
            sections.data.page.modules[0].__typename !== 'DatoCmsCaseIntro'
        ) {
            sections.data.page.modules.unshift({
                __typename: 'DatoCmsCaseIntro',
                id: 'DatoCmsCaseIntro',
                introHeadline: _get(data, 'page.introHeadline', ''),
                intro: _get(data, 'page.intro', ''),
                client: _get(data, 'page.client', ''),
                date: _get(data, 'page.date', ''),
                awards: _get(data, 'page.awards', ''),
                industry: _get(data, 'page.industry', ''),
                tags: _get(data, 'page.tags', ''),
                website: _get(data, 'page.website', ''),
            });
        }

        return data ? (
            <CasePageWrapper
                {...{
                    textColor: _get(data, 'page.textColor.hex', ''),
                }}>
                <CustomHelmet
                    siteSeo={_get(data, 'site.globalSeo', '')}
                    pageSeo={_get(data, 'page.seo', '')}
                    image={seoImage}
                    backgroundColor={_get(data, 'page.backgroundColor.hex', '')}
                    textColor={textColor}
                />
                <HelmetDatoCms
                    favicon={_get(data, 'site.faviconMetaTags', '')}
                />
                <Header
                    {...{
                        ...this.props,
                        getTransitionContent: this.renderWrapper,
                    }}
                />
                <GoBack {...{ getTransitionContent: this.renderWrapper }} />
                <CaseSection caseSections={caseSections} />
                <Sections {...sections} />
                <NextCase
                    case={data.nextcase}
                    invert={
                        pageBackgroundColor == '#fff' ||
                        pageBackgroundColor == '#ffffff'
                    }
                    animate={false}
                />
                {/* <GoBack {...{ getTransitionContent: this.renderWrapper }} fixed={false} /> */}
            </CasePageWrapper>
        ) : (
                <div />
            );
    }

    render() {
        return this.renderWrapper();
    }
}

export const CaseQuery = graphql`
    query caseQuery($slug: String!, $next: String!) {
        site: datoCmsSite {
            ...DatoCmsSiteFragment
        }
        nextcase: datoCmsCase(slug: { eq: $next }) {
            name
            client
            tags {
                tag
            }
            slug
            teaserTitle
            teaserImageWide {
                format
                #removed inlineSvg
                url
                sizes(
                    maxWidth: 1200
                    imgixParams: { fm: "jpg", auto: "compress" }
                ) {
                    aspectRatio
                    src
                    srcSet
                    sizes
                }
                focalPoint {
                    x
                    y
                }
            }
            hero {
                __typename
                ... on DatoCmsHeroImage {
                    ...DatoCmsHeroImageFragment
                }
            }
        }
        page: datoCmsCase(slug: { eq: $slug }) {
            name

            introHeadline
            intro
            client
            date(formatString: "YYYY")
            awards
            industry
            tags {
                id
                tag
            }
            website

            seo {
                title
                description
                twitterCard
                image {
                    format
                    size
                    width
                    height
                    url
                }
            }

            textColor {
                hex
            }
            backgroundColor {
                hex
            }
            teaserImageWide {
                format
                #removed inlineSvg
                url
                sizes(maxWidth: 3000) {
                    ...GatsbyDatoCmsSizes_noBase64
                }
                focalPoint {
                    x
                    y
                }
            }
            teaserImageBackgroundColor {
                hex
            }
            imageBackgroundColor {
                hex
            }
            hero {
                __typename
                ... on DatoCmsCaseHeroText {
                    id
                    title
                    disableDifferenceEffect
                    color {
                        red
                        green
                        blue
                        rgb
                        hex
                    }
                }
                ... on DatoCmsHeroImage {
                    ...DatoCmsHeroImageFragment
                }
            }
            modules {
                __typename
                ... on DatoCmsCaseSection {
                    id
                    sectionTitle
                }
                ... on DatoCmsSideBySideText {
                    id
                    left
                    right
                    backgroundColor {
                        hex
                    }
                    textColor {
                        hex
                    }
                }
                ... on DatoCmsSideBySideImage {
                    id
                    ...DatoCmsSideBySideImageFragment
                }
                ... on DatoCmsGoertekVisualizer {
                    id
                }
                ... on DatoCmsGoertekTypeset {
                    id
                }
                ... on DatoCmsGoertekSlider {
                    id
                    letter
                    media {
                        format
                        #removed inlineSvg
                        url
                        width
                        height
                        sizes(maxWidth: 1000) {
                            ...GatsbyDatoCmsSizes_noBase64
                        }
                        jsonData
                    }
                }
                ... on DatoCmsSideBySideTextImage {
                    id
                    ...DatoCmsSideBySideTextImageFragment
                }
                ... on DatoCmsFullscreenVideoImage {
                    id
                    ...DatoCmsFullscreenVideoImageFragment
                }
                ... on DatoCmsSmallVideoImage {
                    id
                    ...DatoCmsSmallVideoImageFragment
                }
                ... on DatoCmsComparison {
                    id
                    ...DatoCmsComparisonFragment
                }
                ... on DatoCmsLargeVideoImage {
                    id
                    ...DatoCmsLargeVideoImageFragment
                }
                ... on DatoCmsCarousel {
                    id
                    ...DatoCmsCarouselFragment
                }
                ... on DatoCmsTypetester {
                    id
                    ...DatoCmsTypetesterFragment
                }
                ... on DatoCmsSpacer100 {
                    id
                    backgroundColor {
                        hex
                    }
                }
                ... on DatoCmsSpacer200 {
                    id
                    backgroundColor {
                        hex
                    }
                }
                ... on DatoCmsSpacer300 {
                    id
                    backgroundColor {
                        hex
                    }
                }
                ... on DatoCmsQuote {
                    id
                    quote
                    author
                    highlightColor {
                        hex
                    }
                    authorColor {
                        hex
                    }
                    backgroundColor {
                        hex
                    }
                    textColor {
                        hex
                    }
                }
                ... on DatoCmsMarkdownText {
                    id
                    text
                    centerText
                    leftAlignText
                    backgroundColor {
                        hex
                    }
                    textColor {
                        hex
                    }
                }
                ... on DatoCmsTextWithBackground {
                    id
                    text
                    background {
                        format
                        #removed inlineSvg
                        url
                        width
                        height
                        sizes(maxWidth: 3000) {
                            ...GatsbyDatoCmsSizes_noBase64
                        }
                        jsonData
                    }
                    loop
                    backgroundColor {
                        hex
                    }
                    textColor {
                        hex
                    }
                }
                ... on DatoCmsContactPerson {
                    id
                    title
                    person {
                        ...DatoCmsPersonFragment
                    }
                    body
                }
            }
        }

        menu: datoCmsMenuItem {
            largeMenuItems {
                id
                slug
                name
                redirect
            }
            smallMenuItems {
                id
                slug
                name
                redirect
            }
        }
    }
`;
